import { AxiosError } from 'axios';
import { GET_GROUP_EXAM_REGISTRATION_TEMPLATE_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { ExamType } from '../../api/candidate/exam/model';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_GROUP_EXAM_REGISTRATION_TEMPLATE_URL_QUERY_KEY } from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  enabled?: boolean;
  onSuccess?: (data: GetUploadTemplateDownloadUrlResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
  examType?: ExamType;
}

interface GetUploadTemplateDownloadUrlResponse {
  url: string;
}

export const useGetUploadTemplateDownloadUrl = ({
  uuid,
  examType,
  enabled = false,
  onSuccess,
  onError,
}: Input) => {
  const getUploadTemplateDownloadUrl = async () => {
    const res = await axiosClient.get<GetUploadTemplateDownloadUrlResponse>(
      GET_GROUP_EXAM_REGISTRATION_TEMPLATE_URL(uuid, examType)
    );
    return res.data;
  };
  return useCustomQuery(
    [GET_GROUP_EXAM_REGISTRATION_TEMPLATE_URL_QUERY_KEY],
    getUploadTemplateDownloadUrl,
    {
      onSuccess,
      onError,
      enabled,
    },
  );
};
